module.exports = __webpack_public_path__ + "img/ruby_slippers.f0eedb25.jpg";